// frontend/src/socket.js
import { io } from "socket.io-client";

const socket = io(
  process.env.NODE_ENV === "production"
    ? "https://api.coinzetto.com" // ✅ your deployed backend
    : "http://localhost:5000",     // ✅ dev backend
  {
    autoConnect: false,
    transports: ["websocket"],
  }
);

export default socket;
